import { CubeIcon, IconBox } from "@hightouch/htui";
import { SchemaIconProps } from "./types";

export const ParentIcon = ({ size = "xl", ...props }: SchemaIconProps) => {
  return <IconBox color="indigo" icon={<CubeIcon />} size={size} {...props} />;
};
